import {
    SiNetflix,
    SiPlaystation,
    SiSpotify,
    SiFitbit,
    SiUdemy,
    SiSlack,
    // ... other service icons from your list ...
} from 'react-icons/si';

import {
    Monitor,
    Music,
    Gamepad2,
    Briefcase,
    Cloud,
    Dumbbell,
    GraduationCap,
    ShieldCheck,
    ShoppingCart,
    Heart,
    Globe,
    Newspaper,
    Zap,
    LayoutGrid,
    MoreHorizontal
} from 'lucide-react';

import { subscriptionConfigs } from './subscriptionData'

// Generic category icons using Lucide
export const categoryIcons = {
    streaming: Monitor,
    music: Music,
    gaming: Gamepad2,
    productivity: Briefcase,
    cloud: Cloud,
    business: Briefcase,
    creative: LayoutGrid,
    education: GraduationCap,
    fitness: Dumbbell,
    wellness: Heart,
    security: ShieldCheck,
    shopping: ShoppingCart,
    dating: Heart,
    entertainment: Monitor,
    sports: Gamepad2,
    news: Newspaper,
    other: Globe
};

// Generic icons for custom services
export const genericIcons = [
    { id: 'entertainment', icon: Monitor, label: 'Entertainment' },
    { id: 'music', icon: Music, label: 'Music' },
    { id: 'gaming', icon: Gamepad2, label: 'Gaming' },
    { id: 'business', icon: Briefcase, label: 'Business' },
    { id: 'cloud', icon: Cloud, label: 'Cloud' },
    { id: 'fitness', icon: Dumbbell, label: 'Fitness' },
    { id: 'education', icon: GraduationCap, label: 'Education' },
    { id: 'security', icon: ShieldCheck, label: 'Security' },
    { id: 'shopping', icon: ShoppingCart, label: 'Shopping' },
    { id: 'lifestyle', icon: Heart, label: 'Lifestyle' },
    { id: 'other', icon: MoreHorizontal, label: 'Other' }
];

// Get subscription config by service ID
export const getSubscriptionConfig = (serviceId) => {
    return subscriptionConfigs.find(config => 
        config.id.toLowerCase() === serviceId.toLowerCase()
    );
};

// Get icon by service name
export const getServiceIcon = (serviceName) => {
    const config = subscriptionConfigs.find(config =>
        config.id.toLowerCase() === serviceName.toLowerCase()
    );
    return config?.icon || categoryIcons.other;
};

// Get generic icon by category
export const getGenericIcon = (categoryId) => {
    const genericIcon = genericIcons.find(icon => icon.id === categoryId);
    return genericIcon?.icon || categoryIcons.other;
};

// Get all available icons (both service-specific and generic)
export const getAllIcons = () => {
    return {
        serviceIcons: subscriptionConfigs.map(config => ({
            id: config.id,
            icon: config.icon,
            label: config.name
        })),
        genericIcons
    };
}; 